/**
 * @fileOverview
 * Isomorphic implementation of all user session related functions. Testing for authentication state, getting headers
 * for communications with Eagle etc.
 */

const omitBy = require("lodash/omitBy");
const isNil = require("lodash/isNil");

const getCookies = (cookies) => ({
  // TODO: what is the difference between guestToken (set when a cart is created) to guest_token that is set by Eagle.
  //  Feels like guest_token should be the source of truth. investigate
  guestToken: cookies.get("guestToken"),
  // this cookie is set by eagle when a user is authenticated and should be the only source of truth for authentication state
  restrictedUserId: cookies.get("restricted_user_id"),
  locale: cookies.get("locale"),
  currency: cookies.get("currency"),
  countryCode: cookies.get("country_code"),

  /** @deprecated favour the camel case version of the cookie name */
  userToken: cookies.get("restricted_user_id"),
  /** @deprecated favour the camel case version of the cookie name */
  countryIso: cookies.get("country_code"),
});

// TODO: use this as the only session header factory across the entire app
const getEagleSessionHeaders = (
  cookies,
  { locale, currency, guestToken, iso } = {}
) => {
  cookies = getCookies(cookies);
  return omitBy(
    {
      LMN_RESTRICTED_USER: cookies.restrictedUserId,
      LMN_GUEST_TOKEN: guestToken || cookies.guestToken,
      LMN_LOCALE: locale || cookies.locale,
      LMN_CURRENCY: currency || cookies.currency,
      LMN_COUNTRY_ISO: iso || cookies.countryCode,
      "content-type": "application/json",
    },
    isNil
  );
};

const isAuthenticated = (cookies) => !!cookies.get("restricted_user_id");

module.exports = {
  getCookies,
  getEagleSessionHeaders,
  isAuthenticated,
};
